import React, { useEffect, useState } from "react";
import { Button, Row, Toast, Col } from "react-bootstrap";
import { api } from "./pureFunctions";
import gearIcon from "./img/gear.png";
import { header } from "./globalVariables";
import { goToOOAddress } from "./networkFunctions";
import { useConfig } from "./ConfigContext";

export default function BrowserNotifications({}) {
   const config=useConfig().nutzerEinstellungen
   const [showAll, setShowAll] = useState(false);
   const [notificationData, setNotificationData] = useState({});
   const [settings, setSettings] = useState({});

   const toggleShowAll = () => setShowAll((prev) => !prev);

   async function removeNotification(type, index) {
      let newNotData = structuredClone(notificationData);
      newNotData[type].splice(index, 1);
      await updateUserData(newNotData);
      setNotificationData(newNotData);
   }

   async function updateUserData(data) {
      console.log(data);
      console.log(config);
      

      const savedResponse = await api.post("/api/ip/userData", { notifications: data }, header).then((data) => {
         console.log("saved Data");
         console.log(data);
      });
   }

   async function getUserData() {

      console.log(config);
      
      try {
         const data = await api.get(`api/ip/userdata`, {
            params: {
               reqData: ["notifications", "settings"],
            },
            ...header,
         });
         let newNots = data?.data?.notifications ?? {};
         // setSettings(data?.data?.settings?.notifications ?? config.notifications);
         setSettings(data?.data?.settings?.notifications ?? {});
         console.log(data);
         console.log(newNots);
         setNotificationData(newNots);
      } catch (err) {
         console.log(err);
      }
   }

   useEffect(() => {
      getUserData();
   }, []);

   function countNotifications(data) {
      let n = 0;
      Object.keys(data).forEach((itemKey) => {
         if (settings?.[itemKey] && data?.[itemKey]?.length) n += data[itemKey].length;
      });
      return n;
   }

   return (
      <div
         style={{
            boxShadow: "0 0 10px #000",
            position: "absolute",
            right: 10,
            top: 10,
            zIndex: 100,
            borderRadius: 100
         }}
      >
         <Button
            onClick={() => {
               toggleShowAll();
            }}
            variant={countNotifications(notificationData) ? "danger" : "light"}
            style={{ borderRadius: 100, height: "40px", width: "40px", padding: 0 }}
         >
            {countNotifications(notificationData) || <img src={gearIcon} alt="N" width="28" />}
         </Button>
         {showAll && (
            <div
               className=""
               style={{
                  background: "#fff4",
                  boxShadow: "0 0 10px #000",
                  backdropFilter: "blur(2px)",
                  padding: 10,
                  borderRadius: 10,
                  position: "absolute",
                  right: 0,
                  top: 60,
                  zIndex: 100,
                  display: "flex",
                  flexDirection: "column",
               }}
            >
               <div className="bg-white text-center">
                  <a className="btn btn-dark" href="/nutzereinstellungen">
                     Nutzereinstellungen
                  </a>

                  {countNotifications(notificationData) > 0 && (
                     <>
                        <hr /> <h5 className="mb-0 p-1">Benachrichtigungen</h5>
                     </>
                  )}
               </div>
               {Object.keys(notificationData).map((notKey) => {
                  if (settings[notKey])
                     return (
                        <>
                           {notificationData?.[notKey]?.map((notItem, index) => {
                              let { heading, text, link, linkName, t, addressId } = handleNotificationTypes(
                                 notKey,
                                 notItem,
                              );

                              let timeString = "";
                              if (t) {
                                 timeString =
                                    new Date() - t > 3600000
                                       ? t?.toLocaleString()
                                       : Math.floor((new Date() - t) / 60000) + "min";
                              }

                              return (
                                 <Toast
                                    className="my-2"
                                    // show={notItem.status === "active"}
                                    onClose={() => {
                                       removeNotification(notKey, index);
                                    }}
                                 >
                                    <Toast.Header>
                                       <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
                                       <strong className="me-auto">{heading}</strong>
                                       <small>{timeString}</small>
                                    </Toast.Header>
                                    <Toast.Body>
                                       {text}
                                       <div className="text-center">
                                          {link && (
                                             <a href={link} target="_blank">
                                                {linkName ?? "Link"}
                                             </a>
                                          )}
                                          {addressId && (
                                             <Button
                                                className="m-1"
                                                onClick={() => {
                                                   goToOOAddress(addressId);
                                                }}
                                             >
                                                {linkName || "Link"}
                                             </Button>
                                          )}
                                       </div>
                                    </Toast.Body>
                                 </Toast>
                              );
                           })}
                        </>
                     );
               })}
            </div>
         )}
      </div>
   );
}

function handleNotificationTypes(type, item) {
   let formattedNotifications = [];

   if (type === "akquiseRueckfrage") {
      formattedNotifications = {
         heading: "Akquisekunde",
         text: `Das Rückrufdatum von ${item.Vorname} ${item.Name} ist fällig!`,
         link: "",
         linkName: `KdNr: ${item.KdNr}`,
         t: new Date(item.ind_2582_Feld_adressen73),
         addressId: item.id,
         status: "active",
      };
   }

   return formattedNotifications;
}
